module.exports = __webpack_public_path__ + "media/Video 5.7e8aa7cd.mp4";